<template>
  <div class="edit_profile">

    <div class="edit_profile__name">
      <fg-input
          class="name"
          v-model="notification.noticeName"
          type="text"
          label="Name profile"
          :placeholder="this.translate('notification.placeholder')"
      />
      <div class="status">
        <div class="info">
          {{this.translate('notification.edit.status')}}
          <span class="sign">&#128712;</span>
          <span class="text">
            {{this.translate('notification.edit.status_text')}}
          </span>
        </div>
        <label class="switch" @click.prevent="notification.status = !notification.status">
          <input type="checkbox" v-model="notification.status">
          <span class="slider round"></span>
        </label>
      </div>
      <span class="button" >
        <button class="btn btn-success btn-fill"
          v-if="check_send"
          @click="pre_save_notif()"
          :disabled='disabled_btn'
        >
          <i class="mdi mdi-plus-circle-outline" /> {{this.translate('save')}}
        </button>
        <!-- <button @click="next_block()" class="btn btn-success btn-fill" v-if="check_devices">
          <i class="mdi mdi-plus-circle-outline" /> Next
        </button> -->
      </span>
    </div>

    <div class="edit_profile__block">
      <div class="notice-item">
        <div class="tab">
          <span
              class="noticeEditItemTitle"
              :class="{ active : block==='DeviceList'}"
              @click="selected_block('DeviceList')"
          >
            {{ translate('notification.edit.devices_list') }}
          </span>
          <span
              class="noticeEditItemTitle"
              :class="{ active : block==='TriggerList', disabled : !check_devices}"
              @click="selected_block('TriggerList')"
          >
            {{ translate('notification.edit.triggers_list')}}
          </span>
          <span
              class="noticeEditItemTitle"
              :class="{ active : block==='Channels', disabled : !check_triggers}"
              @click="selected_block('Channels')"
          >
            {{ translate('notification.edit.channels_list')}}
          </span>
        </div>
        <div class="block">
          <NotificationDeviceList v-if="block==='DeviceList'" :notification="notification" :list_devices="edit_list_devices" @devices="update_list_devices"/>
          <NotificationTrigger v-if="block==='TriggerList'" :notification="notification"/>
          <NotificationChannel v-if="block==='Channels'" :notification="notification" :channels_list="channels_list"/>
        </div>
      </div>
    </div>


  </div>

</template>

<script>

import NotificationChannel from "./NotificationEdit/Channel";
import NotificationTrigger from "./NotificationEdit/TriggerList";
import NotificationDeviceList from "./NotificationEdit/DeviceList";

export default {
  name: "NotificationEdit",
  components: {
     NotificationTrigger,
     NotificationChannel,
     NotificationDeviceList
  },
  data () {
    return {
      block: 'DeviceList',
      notification: {
        noticeName: '',
        devices: [],
        groups: [],
        triggers: [],
        channels: [],
        status: true,
        id: null,
        valid_for: '',
        valid_trigger_block: ''
      },
      edit_list_devices: [],
      disabled_btn: false
    }
  },
  props: ['notice','list_devices', 'channels_list', 'source'],

  created () {
    this.check_notice()
    this.check_list_devices()

    if (this.source === 'device'){
      this.block = 'TriggerList'
      this.notification.noticeName = this.notice.devices[0].name2
    }
  },

  computed: {
    check_send () {
      if (this.notification.triggers.length > 0 && this.notification.channels.length > 0 && this.notification.noticeName !== '') {
        if (this.notification.devices.length > 0 || this.notification.groups.length > 0) {
          return true
        }
      }
      return false
    },

    check_devices () {
      return this.notification.devices.length > 0 || this.notification.groups.length > 0
    },
    check_triggers(){
      return this.notification.triggers.length > 0
    }
  },

  methods: {
    update_list_devices(value){
      this.edit_list_devices = value
    },
    check_list_devices(){
      if(typeof(this.list_devices) != "undefined") {
        this.edit_list_devices = this.list_devices
      }
    },
    check_notice(){
      if(typeof(this.notice) != "undefined" && this.notice !== null) {
        this.notification.noticeName = this.notice.name
        this.notification.id = this.notice.id

        if (this.notice.devices) {
          this.notification.devices = [...this.notice.devices]
        }
        if (this.notice.groups) {
          this.notification.groups = [...this.notice.groups]
        }

        this.notification.status = this.notice.status === 1;

        for (let st in this.notice.sendto) {
          for (let channel of this.channels_list) {
            channel.check = false
            if (channel.id === this.notice.sendto[st].channel_id) {
              channel.check = true
              this.notification.channels.push(channel)
            }
          }
        }

        for (var tr in this.notice.triggers) {
          let params = JSON.parse(this.notice.triggers[tr].params)
          let item = {id: this.notice.triggers[tr].id, definition_id: this.notice.triggers[tr].definition_id, params: params, type: params.type, timer: params.timer, time: true}
          this.notification.triggers.push(item)
        }

        if (this.notification.devices.length === 1 && this.notification.groups.length < 1) {
          this.notification.valid_for = 'device'
          this.notification.valid_trigger_block = 'device'
        } else {
          this.notification.valid_for = 'group'
          this.notification.valid_trigger_block = 'group'
        }
      }
    },

    selected_block(block){
      if (block === 'DeviceList') {
        this.block = 'DeviceList'
      }else if (block === 'TriggerList') {
        if (this.notification.devices.length > 0 || this.notification.groups.length > 0) {
          this.block = 'TriggerList'
        }
      }else if (block === 'Channels') {
        if (this.notification.triggers.length > 0) {
          this.block = 'Channels'
        }
      }
    },

    checking_type_triggers(){
      if (this.notification.devices.length > 0 || this.notification.groups.length > 0) {
        if (this.notification.valid_trigger_block !== '') {
          if (this.notification.valid_for === this.notification.valid_trigger_block) {
            return true
          }else{
            if (this.notification.triggers.length > 0) {
              if (confirm(this.translate('notification.change_devices'))) {
                for (let tr in this.notification.triggers) {
                  if (this.notification.triggers[tr].block_devices === this.notification.valid_trigger_block) {
                    this.notification.triggers.splice(tr,1)
                  }
                }
                return true
              }
            }
          }
        }else{
          return true
        }
      }
      return false
    },
    pre_save_notif(){
      if (this.checking_type_triggers()) {
        this.save_notification()
      }
    },
    save_notification(){
      let notice = { name: this.notification.noticeName }

      if (this.notification.id != null) {
        notice.id = this.notification.id
      }

      if (this.notification.channels.length > 0) {
        let sendto = []
        for (var channel of this.notification.channels) {
          sendto.push({channel_id: channel.id, prefix: ''})
        }
        notice.sendto = sendto
      }

      if (this.notification.devices.length > 0) {
        let devices = []
        for (var device of this.notification.devices) {
          devices.push({device_id: device.id})
        }
        notice.devices = devices
      }else{
        notice.devices = []
      }

      if (this.notification.groups.length > 0) {
        let groups = []
        for (var group of this.notification.groups) {
          groups.push({group_id: group.id})
        }
        notice.groups = groups
      }else{
        notice.groups = []
      }

      if (this.notification.triggers.length > 0) {

        let triggers = []
        for (var tr in this.notification.triggers) {
          this.notification.triggers[tr].params.type = this.notification.triggers[tr].type
          if(typeof(this.notification.triggers[tr].params.timer) == "string") {
            this.notification.triggers[tr].params.timer = parseInt(this.notification.triggers[tr].params.timer)
          }

          if(this.notification.triggers[tr].params.type === "int" || this.notification.triggers[tr].params.type === "float") {
            this.notification.triggers[tr].params.crit = parseInt(this.notification.triggers[tr].params.crit)
            this.notification.triggers[tr].params.normal = parseInt(this.notification.triggers[tr].params.normal)
          }

          if (this.notification.triggers[tr].params.type !== "list") {
            delete this.notification.triggers[tr].params.element
          }else{
            delete this.notification.triggers[tr].params.crit
            delete this.notification.triggers[tr].params.normal
          }

          if (this.notification.triggers[tr].id) {
            triggers.push({id: this.notification.triggers[tr].id, definition_id: this.notification.triggers[tr].definition_id, params: JSON.stringify(this.notification.triggers[tr].params)})
          }else{
            triggers.push({definition_id: this.notification.triggers[tr].definition_id, params: JSON.stringify(this.notification.triggers[tr].params)})
          }
        }
        notice.triggers = triggers
      }

      if (this.notification.status) {
        notice.status = 1
      }else{
        notice.status = 0
      }

      this.disabled_btn = true

      this.$http.v1.saveNotification({notification: notice}, (response) => {
        if (response.data.code === 101){
          this.global_notify('danger', this.translate('notification.saved_error'))
          this.disabled_btn = false
        }else{
          this.global_notify('info', this.translate('notification.saved'))
        }

        this.$emit('reload')
        this.$emit('close')

      })
    }
  },
}
</script>

<style lang="scss">
  .edit_profile{
    height: 100%;
    padding: 20px;
    &__name{
      display: flex;
      justify-content: space-between;
      .name{
        display: inline-block;
        width: 60%;
      }
      .button{
        display: inline-block;
        width: 18%;
        button{
          margin-top: 25px;
          width: 100%;
        }
      }
      .status{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column-reverse;
        margin-top: 14px;
        .switch {
          position: relative;
          display: inline-block;
          width: 45px;
          height: 22px;
          margin-bottom: 0;
        }
        .switch input {
          display:none;
        }
        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          -webkit-transition: .4s;
          transition: .4s;
        }

        .slider:before {
          position: absolute;
          content: "";
          height: 16px;
          width: 16px;
          left: 6px;
          bottom: 3px;
          background-color: white;
          -webkit-transition: .4s;
          transition: .4s;
        }

        input:checked + .slider {
          background-color: #41B883;
        }

        input:focus + .slider {
          box-shadow: 0 0 1px #41B883;
        }

        input:checked + .slider:before {
          transform: translateX(18px);
        }

        /* Rounded sliders */
        .slider.round {
          border-radius: 34px;
        }

        .slider.round:before {
          border-radius: 50%;
        }
        .info{
          position: relative;
          .text{
            position: absolute;
            width: 200px;
            top: 100%;
            left: -50%;
            background: #f9f9f9;
            padding: 10px;
            border-radius: 5px;
            opacity: 0;
            z-index: -10;
            transition: 0.2s;
            box-shadow: 1px 1px 5px #202020;
          }
          .sign{
            cursor: help;
            &:hover + .text{
              opacity: 1;
              z-index: 10;

            }
          }
        }
      }
    }
    .notice-item{
      width: 100%;
      height: 100%;
      .tab{
        width: 100%;
        .noticeEditItemTitle {
          display: inline-block;
          width: 33.3%;
          padding: 5px 0;
          cursor: pointer;
          font-weight: 600;
          text-align: center;
          &.active {
            border: 1px solid #efe9e9;
            border-bottom: 1px solid white;
          }
          &.disabled{
            border: 1px solid #efe9e9;
            background: #eee;
          }
        }
      }
      .block{
         border: 1px solid #efe9e9;
         height: 480px;
         margin-top: -1px;
      }
    }
  }

@media (max-width: 700px) {
  .edit_profile{
    &__name{
      flex-wrap: wrap;
      margin-bottom: 10px;
      .name{
        width: 100%;
      }
      .status{
        width: 50%;
        margin-top: 0;
      }
      .button{
        width: 50%;
        button{
          margin-top: 0;
        }
      }
    }
    .notice-item{
      .block {
        height: 350px;
      }
    }
  }
}

</style>
